module.exports = __webpack_public_path__ + "img/3-text.ad920794.png";